import React from 'react';
import PropTypes from 'prop-types';
import { constants } from '@brochure/shared';

const Share = ({ urlPath }) => {
  const { domains } = constants;

  return (
    <section className="post-single__share">
      <h2 className="share__title" aria-label="Share this article">
        Share
      </h2>
      <ul className="share__list">
        <li className="share__list-item">
          <a
            className="share__link facebook"
            href={`https://www.facebook.com/sharer/sharer.php?u=https://${domains.www}${urlPath}`}
          >
            <div className="visuallyHidden">Share on Facebook</div>
          </a>
        </li>
        <li className="share__list-item">
          <a
            className="share__link twitter"
            href={`https://twitter.com/home?status=https://${domains.www}${urlPath}`}
          >
            <div className="visuallyHidden">Share on Twitter</div>
          </a>
        </li>
        <li className="share__list-item">
          <a
            className="share__link linkedin"
            href={`https://www.linkedin.com/shareArticle?mini=true&url=https://${domains.www}${urlPath}&title=&summary=&source=`}
          >
            <div className="visuallyHidden">Share on LinkedIn</div>
          </a>
        </li>
        <li className="share__list-item">
          <a
            className="share__link pinterest"
            href={`https://pinterest.com/pin/create/button/?url=https://${domains.www}${urlPath}&media=&description=`}
          >
            <div className="visuallyHidden">Share on Pinterest</div>
          </a>
        </li>
      </ul>
    </section>
  );
};

Share.propTypes = {
  urlPath: PropTypes.string.isRequired,
};

export default Share;
